import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalFooter } from 'react-bootstrap';
import PropTypes from 'prop-types';

export default class ConfirmModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.onHide}>
                <Modal.Header>
                    <Modal.Title> {this.props.headerText} </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>{this.props.bodyText}</div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.onHide}>Cancel</Button>
                    <Button className={`btn ${this.props.buttonType}`} onClick={this.props.onConfirmed}>
                        {this.props.buttonText}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
ConfirmModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onConfirmed: PropTypes.func.isRequired,
    bodyText: PropTypes.string,
    headerText: PropTypes.string,
    buttonText: PropTypes.string,
    buttonType: PropTypes.string,
};
ConfirmModal.defaultProps = {
    bodyText: 'Are you sure you want to do that?',
    headerText: 'Confirm',
    buttonText: 'Confirm Delete',
    buttonType: 'bnt-danger',
};



// WEBPACK FOOTER //
// ./src/shared/confirm-modal.js